import React, {Component} from 'react';
import {Col, Row} from "react-bootstrap";
import {SortableHandle} from "react-sortable-hoc";
import InlineInput from "../../../../../shared/inlineFormsControl/InlineInput";
import InlineSelect from "../../../../../shared/inlineFormsControl/InlineSelect";
import {TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";

const DragHandle = SortableHandle(() => <i className={'fa fa-bars'}></i>);

export default class DefinicjeTrasSortableItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edytujCzasOdPoprzedniego: false,
            edytujKmOdPoprzedniego: false,
            edytujPrzystanek: false,
        };
        this.edytujCzasOdPoprzeniego = this.edytujCzasOdPoprzeniego.bind(this)
        this.edytujKmOdPoprzedniego = this.edytujKmOdPoprzedniego.bind(this)
        this.edytujPrzystanek = this.edytujPrzystanek.bind(this)
        this.onZapiszCzasOdPoprzedniego = this.onZapiszCzasOdPoprzedniego.bind(this)
        this.onZapiszKmOdPoprzedniego = this.onZapiszKmOdPoprzedniego.bind(this)
        this.onZapiszPrzystanek = this.onZapiszPrzystanek.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
    }

    renderPrzystanek(id) {
        let przystanek = this.props.przystanki.find(p => p.idPr === id)

        if (Boolean(przystanek)) {
            return <span><span className={'label label-ebus-primary'} style={{marginRight: '7px'}}> {przystanek.nazMi}</span>{przystanek.nazPr}</span>
        }

    }

    edytujCzasOdPoprzeniego() {
        this.setState({edytujCzasOdPoprzedniego: true})
    }

    edytujKmOdPoprzedniego() {
        this.setState({edytujKmOdPoprzedniego: true})
    }

    edytujPrzystanek() {
        this.setState({edytujPrzystanek: true})
    }

    onZapiszCzasOdPoprzedniego(obj) {
        this.setState({edytujCzasOdPoprzedniego: false})
        this.props.handleChangeWartosc(obj);
    }

    onZapiszKmOdPoprzedniego(obj) {
        this.setState({edytujKmOdPoprzedniego: false})
        this.props.handleChangeWartosc(obj);
    }

    onZapiszPrzystanek(obj) {
        this.setState({edytujPrzystanek: false})
        this.props.handleChangeWartosc(obj);
    }

    onClickUsun(obj){
        if (window.confirm('Czy usunąc definicje?')) {
            this.props.handleUsun(obj)
        }
    }

    render() {

        return (
            <div className={'defItem'}>
                <Row>
                    <Col xs={12} lg={1}>
                        <DragHandle/>
                        {this.props.item.kol}
                    </Col>
                    <Col xs={12} lg={1}>
                        {this.props.item.czasOdPocz}
                    </Col>
                    <Col xs={12} lg={5}>
                        <Row>
                            <Col xs={12} lg={8}>
                                {
                                    (this.state.edytujPrzystanek && !this.props.disabledLabel)?
                                        <InlineSelect val={this.props.item.idPr} item={this.props.item} itemvalue={"idPr"}
                                                      options={this.props.przystanki}
                                                      handleClickZapisz={this.onZapiszPrzystanek}
                                                      valKey={'idPr'}
                                                      labelKey={'nazMi'}
                                                      optionRenderer1={'nazMi'}
                                                      optionRenderer2={'nazPr'}
                                                      handleAnuluj={()=>this.setState({edytujPrzystanek:false})}
                                        />
                                        :
                                        <div>
                                            {this.renderPrzystanek(this.props.item.idPr)}
                                            <i className={'fa fa-pencil'} style={{marginLeft: '15px', cursor: 'pointer'}}
                                               onClick={this.edytujPrzystanek}></i>
                                        </div>
                                }
                            </Col>
                            <Col xs={12} lg={4}>
                                <div style={{fontSize:'12px'}}>
                                    <div><span style={{color:'grey'}}>sz:</span> {Boolean(this.props.item.szGps)?this.props.item.szGps:'-'}</div>
                                    <div><span style={{color:'grey'}}>dł:</span> {Boolean(this.props.item.dlGps)?this.props.item.dlGps:'-'}</div>
                                </div>

                            </Col>
                        </Row>

                    </Col>
                    <Col xs={12} lg={4}>
                        <Row>
                            <Col xs={12} lg={6}>
                                {
                                    (this.state.edytujCzasOdPoprzedniego) ?
                                        <InlineInput val={this.props.item.czasOdPoprz} item={this.props.item} itemvalue={"czasOdPoprz"}
                                                     handleClickZapisz={this.onZapiszCzasOdPoprzedniego} validateDouble={false}
                                                     handleAnuluj={()=>this.setState({edytujCzasOdPoprzedniego:false})}
                                        />
                                        :
                                        <div>
                                            {this.props.item.czasOdPoprz}
                                            <i className={'fa fa-pencil'} style={{marginLeft: '15px', cursor: 'pointer'}}
                                               onClick={this.edytujCzasOdPoprzeniego}></i>
                                        </div>
                                }
                            </Col>
                            <Col xs={12} lg={6}>

                                {
                                    (this.state.edytujKmOdPoprzedniego) ?
                                        <InlineInput val={this.props.item.kmOdPoprz} item={this.props.item} itemvalue={"kmOdPoprz"}
                                                     handleClickZapisz={this.onZapiszKmOdPoprzedniego} validateDouble={true}
                                                     handleAnuluj={()=>this.setState({edytujKmOdPoprzedniego:false})}
                                        />
                                        :
                                        <div>
                                            {this.props.item.kmOdPoprz}
                                            <i className={'fa fa-pencil'} style={{marginLeft: '15px', cursor: 'pointer'}}
                                               onClick={this.edytujKmOdPoprzedniego}></i>
                                        </div>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} lg={1}>

                        <div className={'pull-right'}>
                            <TopButtonPointRemove onClick={() => {
                            this.onClickUsun(this.props.item)}} titleContent={'Usuń definicję'}/>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/components/DefinicjeTrasSortableItem.js